
const localStorageHeartKey = 'liveStream-heart-timer';

export class HeartService {

    /// =======================================================================================
    /// Heart Methods
    /// =======================================================================================
    static sendHeart(connection) {

        // Check localStorage for 30 second block
        var heartLimit = localStorage.getItem(localStorageHeartKey);

        if (heartLimit) {
            var heartLimitDT = new Date(heartLimit);
            var now = new Date();

            if (heartLimitDT > now) {
                // Prevent the Heart from going out.
                // Still shown locally
                this.addHeart();
                return;
            }
        }


        // SendHeart to SignalR Server
        connection.invoke('Send', 'heart');


        // add localStorage value to prevent posting again for 30 seconds
        const myDate = new Date(); // This will create a Date object representing the current date and time.

        // Adding expiration seconds to the Date object
        myDate.setSeconds(myDate.getSeconds() + 30);

        localStorage.setItem(localStorageHeartKey, myDate);
    }


    static addHeart() {
        var jwplayerEl = document.getElementById('player-1');

        const playerCoords = jwplayerEl.getBoundingClientRect();

        // Add UI Elements
        DEBUG && console.info('==> Add Heart...');
        //DEBUG && console.info(`Top: ${playerCoords.bottom - 50}`);
        //DEBUG && console.info(`Left: ${playerCoords.right - 50}`);

        var masterNode = document.getElementById('heart-source');
        var clone = masterNode.cloneNode(true);

        clone.id = "";
        clone.style.position = 'absolute';

        var heartEl = jwplayerEl.appendChild(clone);
        heartEl.style.top = `${(playerCoords.bottom - 50)}px`;
        heartEl.style.left = `${(playerCoords.right - 50)}px`;
        heartEl.classList.remove("hidden");

        // Run Heart
        setTimeout(function () {
            heartEl.style.transition = "1.5s";
            heartEl.style.transform = "translate(0,-250px)";
            heartEl.classList.add("hidden");
        }, 500);

        // Delete heart
        setTimeout(function () {
            heartEl.parentNode.removeChild(heartEl);
        }, 2000);
    }
}